<template>
    <div>
        <AppHeader />

        <div class="container">
            <img id="enterprise-logo" />
            <p id="greeting"></p>
            <p id="name" class="font-weight-bold"></p>
        </div>

        <form class="number-plate" @submit.prevent="beforeBeginInsp" autocomplete="off" autocorrect="off"
            autocapitalize="off" spellcheck="false">
            <b-form-input :required="blockEmptyLicensePlate && !emptyLicensePlateWarning" :value="numberPlate"
                v-mask="{ regex: '[A-Za-z0-9-]*' }" @input.native="numberPlate = $event.target.value.toUpperCase()"
                class="form-control" type="text" name="plate" id="plate" maxlength="8" size="8" placeholder="AAA 0000"
                :disabled="inspectionClearance === 'BLOCKED'"></b-form-input>

            <b-button class="mt-4" variant="success" type="submit" :disabled="inspectionClearance === 'BLOCKED'">
                Iniciar Vistoria
            </b-button>
        </form>

        <b-alert show variant="warning" v-if="showTransmissionAlert && !isOnline" class="ml-5 mr-5 mb-1 mt-1"
            style="margin: 0">
            <p v-if="!isOnline" class="text-center mb-0">
                Você precisa estar online para transmitir as vistorias
            </p>
        </b-alert>
        <b-alert show variant="primary" v-if="showTransmissionAlert && isOnline" class="ml-5 mr-5 mb-1 mt-1"
            style="margin: 0">
            <p @click="transmitInspections()" class="text-center mb-0">
                Para transmitir todas suas vistorias pendentes clique aqui.
            </p>
        </b-alert>

        <update-button ref="updateButton" @startSearch="(event) => {
            const { blocking } = event
            inspectionClearance = blocking ? 'BLOCKED' : 'ALLOWED'
        }" @endSearch="(event) => {
            const { updateFound } = event
            if (updateFound) {
                inspectionClearance = 'WARN-UPDATE'
            } else {
                inspectionClearance = 'ALLOWED'
            }
        }" @updateFound="() => {
            inspectionClearance = 'WARN-UPDATE'
        }" @startUpdate="() => {
            inspectionClearance = 'BLOCKED'
        }" @endUpdate="() => {
            inspectionClearance = 'ALLOWED';
            this.setEnterpriseConfig();
        }" />

        <div class="d-flex justify-content-center mt-2">
            <div class="input-group-prepend">
                <b-button v-if="deferredPrompt != null || this.isIos()" @click="install" variant="primary">Instalar
                    app</b-button>
            </div>
        </div>
        <AppFooter />

        <before-inspection-modal ref="selectModal" />
    </div>
</template>

<script>
import { BAlert, BButton, BFormInput } from "bootstrap-vue";

import AppFooter from "@/components/Footer.vue";
import Header from "@/components/Header.vue";
import UpdateButton from "@/components/UpdateButton.vue";
import beforeInspectionModal from "@/components/inspection/beforeInspection/beforeInspectionModal.vue";
import Database from "@/controller/database";
import DeviceInfo from "@/controller/deviceInfo";
import Swal from "sweetalert2";

export default {
    name: "Home",
    components: {
        "before-inspection-modal": beforeInspectionModal,
        "update-button": UpdateButton,
        AppFooter,
        AppHeader: Header,
        BButton,
        BFormInput,
        BAlert
    },
    data: function () {
        return {
            numberPlate: null,
            statusPlate: "Placa Normal",
            inspections: [],
            showTransmissionAlert: false,
            deferredPrompt: null,
            isPwaClient: false,
            isOnline: undefined,
            enterpriseConfig: null,
            emptyLicensePlateWarning: null,

            inspectionClearance: "ALLOWED"
        };
    },
    computed: {
        blockEmptyLicensePlate() {
            //const bloquearInicioVistoriaSemPlaca = this.enterpriseConfig?.bloquear_inicio_vistoria_sem_placa?.valor === "1";
            //return bloquearInicioVistoriaSemPlaca && !this.numberPlate;

            // Já que não tem como fazer vistoria sem placa no VEX WEB, não deve ser possível iniciar a vistoria sem placa
            return !this.numberPlate;
        }
    },
    methods: {
        carregaDadosUsuario() {
            this.isPwaClient = window.matchMedia("(display-mode: standalone)").matches;
            const image = document.getElementById("enterprise-logo");
            const p1 = document.getElementById("greeting");
            const p2 = document.getElementById("name");
            image.setAttribute("width", "200px");
            const enterprise = JSON.parse(localStorage.getItem("enterprise"));
            if (localStorage.getItem("enterpriseLogo")) {
                image.src = localStorage.getItem("enterpriseLogo");
            } else {
                const versionamento = Date.now();
                image.src = `https://files.vexsoft.com.br/${enterprise.name}/logo.png?v=${versionamento}`;
            }
            p1.innerHTML = `Seja bem-vindo(a), ${enterprise.userName}`;
            p2.innerHTML = enterprise.name;
            this.$store.commit("setEnterpriseName", enterprise.name);
            this.$store.commit("setEnterpriseId", enterprise.id);
            this.$store.commit("setEnterpriseUserName", enterprise.userName);
            this.$store.commit("setUserType", enterprise.type);
            this.$store.commit("setEnterpriseActive", enterprise.active);
        },
        mostrarAlertaAndroid() {
            const androidMessageAlreadyShown = JSON.parse(sessionStorage.getItem("androidMessageAlreadyShown")) ?? false;
            if (this.IsAndroid() && !androidMessageAlreadyShown) {
                setTimeout(
                    () => {
                        sessionStorage.setItem("androidMessageAlreadyShown", JSON.stringify(true));
                        Swal.fire({
                            title: "Você está utilizando a versão WEB no Android",
                            text: "Para Android possuimos um APP nativo na Play Store. Deseja instala-lo?",
                            confirmButtonText: "Visitar Play Store",
                            cancelButtonText: "Agora não",
                            showConfirmButton: true,
                            showCancelButton: true,
                        }).then((result) => {
                            if (result.isConfirmed) {
                                window
                                    .open(
                                        "https://play.google.com/store/apps/details?id=br.com.inovaclick.Vex",
                                        "_blank"
                                    )
                                    .focus();
                            }
                        });
                    },
                    160
                );
            }
        },
        iniciarContagemRegressivaParaBotaoCancelar(popup) {
            const intervaloEmSegundos = 1000;
            const cancelButton = popup.querySelector('.swal2-cancel');
            if (cancelButton) {
                let countdown = 10;
                cancelButton.disabled = true;

                const countdownInterval = setInterval(() => {
                    countdown--;
                    cancelButton.textContent = `Agora não (${countdown}s)`;
                    if (countdown <= 0) {
                        clearInterval(countdownInterval);
                        cancelButton.disabled = false;
                        cancelButton.textContent = "Agora não";
                        cancelButton.focus();
                    }
                }, intervaloEmSegundos);
            }
        },
        mostrarAlertaIOS() {
            const delayParaAbrirAlerta = 160;
            setTimeout(
                async () => {
                    const result = await Swal.fire({
                        title: "O Aplicativo VEX Já Está Disponível para iPhone",
                        text: "O Vex Web será descontinuado em breve. Portanto, indicamos o uso do nosso novo aplicativo para iOS, deseja baixar agora?",
                        confirmButtonText: "Baixar o APP",
                        cancelButtonText: "Agora não (10s)",
                        showConfirmButton: true,
                        showCancelButton: true,
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                        didOpen: (popup) => this.iniciarContagemRegressivaParaBotaoCancelar(popup)
                    })

                    if (result.isConfirmed) {
                        window
                            .open("https://apps.apple.com/br/app/vexsoft/id6677058357")
                            .focus();
                    }
                },
                delayParaAbrirAlerta
            );
        },
        async mostraAlertPendentes() {
            const database = new Database();
            await database
                .createOrOpenDatabase({ listInspection: true })
                .then((response) => (this.inspections = response))
                .catch(() => (this.inspections = []));

            for (let i = 0; i < this.inspections.length; i++) {
                let vistoria = this.inspections[i];
                if (vistoria.status == "Pendente") {
                    this.showTransmissionAlert = true;
                    break;
                }
            }
        },

        async transmitInspections() {
            this.$router.push("/transmission");
        },

        beginInsp: function () {
            this.$store.commit("clearInspData");
            this.$store.commit("setNumberPlate", this.numberPlate.toUpperCase());
            this.$refs.selectModal.open();
        },

        beforeBeginInsp: async function (event) {
            if (!this.numberPlate && this.emptyLicensePlateWarning) {
                /* TODO: Não implementado: maneira de salvar vistoria sem placa */
                // const showProceedButton = !this.blockEmptyLicensePlate;
                await Swal.fire({
                    title: this.emptyLicensePlateWarning,
                    icon: "warning",
                    showCancelButton: true,
                    showConfirmButton: false,
                    // confirmButtonColor: "#3085d6",
                    // confirmButtonText: "Ignorar e iniciar",
                    cancelButtonColor: "#d33",
                    cancelButtonText: "Cancelar",
                    reverseButtons: true
                });
            }

            if (this.blockEmptyLicensePlate) {
                return;
            }

            if (this.inspectionClearance === "WARN-UPDATE") {
                // Se o estado é de avisar sobre atualização, o usuário pode tentar
                // iniciar uma vistoria mesmo sem atualizar, o que dispara um aviso
                // pedindo confirmação.
                const result = await Swal.fire({
                    title: "Atualização pendente!",
                    text: "Deseja iniciar uma vistoria mesmo sem atualizar?",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    cancelButtonColor: "#d33",
                    confirmButtonText: "Iniciar Vistoria",
                    cancelButtonText: "Cancelar",
                    reverseButtons: true
                });
                if (result.isDismissed) {
                    return;
                } else if (result.isConfirmed) {
                    this.beginInsp();
                    return;
                }
                // Como esse if sempre termina em um return, o estado continuará como WARN-UPDATE,
                // o que impedirá a rechecagem por atualizações
            }

            let updateFound = null;
            try {
                updateFound = await this.$refs.updateButton.lookForUpdates({ blocking: true });
            } catch (error) {
                console.error(error);
                updateFound = false;
            }

            if (!updateFound) {
                this.inspectionClearance = "ALLOWED";
                this.beginInsp();
            }
        },
        async install() {
            open("https://apps.apple.com/br/app/vexsoft/id6677058357")
        },
        isIos() {
            let deviceInfo = new DeviceInfo();
            return deviceInfo.isIos();
        },
        IsAndroid() {
            let userAgent = navigator.userAgent.toLowerCase();
            let android = userAgent.indexOf("android") > -1;
            if (android) return true;
        },
        setEnterpriseConfig() {
            this.enterpriseConfig = JSON.parse(localStorage.getItem("enterpriseConfig"));
            this.emptyLicensePlateWarning = this.enterpriseConfig?.aviso_bloqueio_vistoria_sem_placa?.valor ?? null;
        }
    },
    async created() {
        this.isOnline = navigator.onLine;

        window.addEventListener("beforeinstallprompt", (e) => {
            e.preventDefault();
            // Stash the event so it can be triggered later.
            this.deferredPrompt = e;
        });
        window.addEventListener("appinstalled", () => {
            this.deferredPrompt = null;
        });

        this.setEnterpriseConfig();

        // const versaoDeDados = new VersaoDeDados();
        // let versaoDeDadosAtualizada = await versaoDeDados.versaoDeDadosAtualizada();
        // if (!versaoDeDadosAtualizada) {
        //     const enterpriseToken = this.$store.state.enterprise.enterprise;
        //     console.log("Atualizando versão de dados...");
        //     await downloadAllVexData(enterpriseToken);
        //     console.log("Atualização finalizada");
        // }
    },
    mounted: async function () {
        this.carregaDadosUsuario();
        this.mostrarAlertaAndroid();
        this.mostraAlertPendentes();

        if (this.isIos()) {
            this.mostrarAlertaIOS();
        }
    },
};
</script>

<style scoped>
.mostrarVistorias {
    display: flex;
    position: absolute;
    bottom: 0;
    width: 100vw;
    flex-direction: row-reverse;
    margin-bottom: 26px;
}

.container {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.container img {
    padding-top: 10px;
    padding-bottom: 10px;
}

.form-control {
    height: 60px;
    text-align: center;
}

.number-plate {
    padding: 50px;
    padding-top: 0;
    padding-bottom: 5px;
    display: flex;
    flex-direction: column;
    justify-content: center;
}



.btn-sendInspButton {
    background-color: #ffc101;
    color: black;
}

.installPwaAlertIos {
    padding-left: 20px;
    padding-right: 20px;
    margin-top: 0px;
    margin-bottom: 50px;
    justify-content: center;
}
</style>
